export const iconFontAwesomeMathematicsLessThanEqual = (
	<i className="fa-solid fa-less-than-equal"></i>
);
